import Api from '../api';

export const UpdateRegisterBeginner = async (params: object) => {
  const response = await Api.post(`/update_form_register`, {
    params: { params },
  });
  return response;
};

export const UpdateRegisterExperient = async (params: object) => {
  const response = await Api.post(`/update_form_register_experient`, {
    params: { params },
  });
  return response;
};

export const register_checkout_access = async () => {
  const response = await Api.get(`/register_checkout_access`);
  return response;
};

export const register_checkout_access_former_subscriber = async () => {
  const response = await Api.get(`/register_checkout_access_former_subscriber`);
  return response;
};
